import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { CheckBox } from 'devextreme-react';

// Tableau de disponibilités représentant les jours de la semaine avec des identifiants uniques basés sur des puissances de 2
const DISPONIBILITES = [
  { id: 1, description: 'Lundi' },
  { id: 2, description: 'Mardi' },
  { id: 4, description: 'Mercredi' },
  { id: 8, description: 'Jeudi' },
  { id: 16, description: 'Vendredi' },
  { id: 32, description: 'Samedi' },
  { id: 64, description: 'Dimanche' },
];

interface Props {
  pointEauSelected: number;
  isModeModifier: boolean;
  onChexBoxChange: (value: number) => void
  isHorizontal?: boolean
}

const JoursDisponibilite: React.FC<Props> = ({ pointEauSelected, isModeModifier, onChexBoxChange, isHorizontal = false }) => {
  // État local pour stocker les valeurs des cases à cocher pour chaque jour de la semaine
  const [checkBoxDisponibilite, setCheckBoxDisponibilite] = useState<{ [key: string]: boolean }>(() => {
    const initialCheckBox = {
      'Lundi': false,
      'Mardi': false,
      'Mercredi': false,
      'Jeudi': false,
      'Vendredi': false,
      'Samedi': false,
      'Dimanche': false,
    };

    if (pointEauSelected !== undefined) {
      DISPONIBILITES.forEach(jour => {
        (initialCheckBox as any)[jour.description] = (pointEauSelected & jour.id) !== 0;
      });
    }

    return initialCheckBox;
  });

  const [disponibiliteChange, setDisponibiliteChange] = useState<number>(pointEauSelected || 0);

  // mettre à jour les cases à cocher lorsque le point d'eau sélectionné change
  useEffect(() => {
    if (pointEauSelected !== undefined && pointEauSelected !== disponibiliteChange) {
      setDisponibiliteChange(pointEauSelected);
      const newCheckBoxDisponibilite = {
        'Lundi': false,
        'Mardi': false,
        'Mercredi': false,
        'Jeudi': false,
        'Vendredi': false,
        'Samedi': false,
        'Dimanche': false,
      };

      DISPONIBILITES.forEach(jour => {
        // Utilisation de l'opération bitwise pour déterminer quels jours sont disponibles
        (newCheckBoxDisponibilite as any)[jour.description] = (pointEauSelected & jour.id) !== 0;
      });
      setCheckBoxDisponibilite(newCheckBoxDisponibilite);
    }
  }, [pointEauSelected]);

  // //gestion du changement de valeur des CheckBox
  const onValueChanged = (e: any, id: number) => {
    const isSelected = e.value; // Détermine si la case est cochée ou décochée
    let newDisponibiliteChange = disponibiliteChange;

    if (isSelected) {
      // Ajoute l'ID du jour sélectionné
      newDisponibiliteChange = disponibiliteChange + id;
    } else {
      // Soustrait l'ID du jour désélectionnéD'a
      newDisponibiliteChange = disponibiliteChange - id;
      // Si la nouvelle valeur est négative, on la remet à 0
      if (newDisponibiliteChange < 0) {
        newDisponibiliteChange = 0;
      }
    }
    onChexBoxChange(newDisponibiliteChange); // Retourne la nouvelle valeur au parent
  };

  return (
    <div style={isHorizontal ? { display: 'flex', gap: '8px', alignItems: 'center' } : {}}>
      {DISPONIBILITES.map(jour => (
        <div key={jour.id} >
          <CheckBox
            value={checkBoxDisponibilite[jour.description]} // Valeur actuelle de la case à cocher pour ce jour
            onValueChanged={(e) => onValueChanged(e, jour.id)} // événements pour les changements de valeur
            disabled={isModeModifier} // Désactivation des cases à cocher en mode modification
          />
          {isHorizontal ? jour.description.substring(0, 3) : jour.description}
        </div>
      ))}
    </div>
  );
};

export default JoursDisponibilite;
